import ShModel from 'sh-www/models/sh-model';
import { attr, belongsTo, hasMany } from '@ember-data/model';
import { htmlSafe } from '@ember/template';

const TYPE_LINK = 'link'; // generic embed data with link to the resource
const TYPE_PHOTO = 'photo'; // used for representing static photos
const TYPE_RICH = 'rich'; // rich HTML content that does not fall under one of the other categories
const TYPE_VIDEO = 'video'; // used for representing playable videos

export const TYPES = [
  TYPE_LINK,
  TYPE_PHOTO,
  TYPE_RICH,
  TYPE_VIDEO,
];

class Oembed extends ShModel {
  @attr('string') type;
  @attr('string') url;
  @attr('string') title;
  @attr('string') pageUrl;
  @attr('string') embedUrl;
  @attr('number') width;
  @attr('number') height;
  @attr('string') providerName;
  @attr('string') lastError;
  @attr('date') deletedAt;

  @belongsTo('image', { async: false }) image;
  @belongsTo('user', { async: false }) user;
  @hasMany('oembedTag', { async: false }) tags;

  get aspectRatioStyle() {
    // default if property unavailable
    if (!this.width || !this.height) {
      return htmlSafe(`aspect-ratio: 16 / 9;`);
    }

    return htmlSafe(`aspect-ratio: ${this.width} / ${this.height};`);
  }

  get isBrokenVideo() {
    return 'not_found' === this.lastError
      && TYPE_VIDEO === this.type;
  }

  get isFacebookVideo() {
    return 'Facebook' === this.providerName;
  }

  get isVimeoVideo() {
    return 'Vimeo' === this.providerName;
  }

  get isYouTubeVideo() {
    return 'YouTube' === this.providerName;
  }

  get videoEmbedUrl() {
    if (this.isYouTubeVideo && this.embedUrl) {
      return this.embedUrl.replace('youtube.com/', 'youtube-nocookie.com/');
    }

    return this.embedUrl;
  }
}

export default Oembed;
